import { toast } from 'react-toastify';
import { config } from '../../Config';
import GetChatStatus from './GetChatStatus';

const DeleteChat = async (chatId, userId) => {
    const status = await GetChatStatus(chatId, userId);
    if (status === 'public') {
        toast.error('This chat is public and cannot be deleted. Please make it private to perform the deletion.');
        return false;
    }
    const url = config.deleteChat;

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ chatId, userId }),
        });

        if (!response.ok) {
            throw new Error(`Failed to delete chat: ${response.statusText}`);
        }

        toast.success('Chat deleted successfully.');
        return true;
    } catch (error) {
        toast.error(`Error deleting chat: ${error.message}`);
        return false;
    }
};

export default DeleteChat;
